<template>
<div>

  <h2 class="block-title push">{{labelTitleSection[actualLanguage]}}</h2>

  <div v-if="flagDisplayAddOrganization" class="col-xs-12 col-sm-12 push">

      <button v-if="flagDisplayTable"  type="button" @click="toggleDisplayAddOrganization()" class="btn btn-default align-right" name="buttonAddPlanItem">
      <i class="fa fa-times fa-1x push-5-r "></i>{{ labelButtonAddOrganization[actualLanguage] }}</button> 

  </div>
  <div v-else  class="col-xs-12 col-sm-12 push">

      <div class="content content-boxed">
        <div class="block block-bordered">
          <div  class="block-content">
            <div class="row">
              <div class="col-xs-12 col-sm-12 push">
                <button  type="button" @click="toggleDisplayAddOrganization()" class="btn btn-default align-right" name="buttonAddPlanItem">
                <i class="fa fa-times fa-1x push-5-r "></i>{{ labelButtonCancel[actualLanguage] }}</button>
              </div>

              <div class="col-xs-12 col-sm-6">
                  <h6>{{labelOrganizationToAddId[actualLanguage]}}</h6>
                  <input v-model="organizationToAddId" class="form-control align-center" type="test"  placeholder="XXXXX">
              </div>

              <div class="col-xs-12 col-sm-6 push">
                  <h6>{{labelOrganizationToPhoneNumber[actualLanguage]}}</h6>
                  <input v-model="organizationToAddPhoneNumber" class="form-control align-center" type="test"  placeholder="XXX-XXX-XXXX">
              </div>

              <div class="col-xs-12 col-sm-12 push">
              
                <p><button @click="addNewOrganisation()" type="button" class="btn btn-success align-right" name="button">
                  <spinner size="small" v-if="organizationIsSaving"></spinner>
                  <span v-else><i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAdd[actualLanguage] }}</span></button></p>

              </div>

            </div>
          </div>
        </div>
      </div>

  </div>


  <div class="col-xs-12 col-sm-12 push">
    <spinner size="normal" v-if="organizationListIsLoading"></spinner>
    <div v-else class="col-xs-12 col-sm-12 push">

      <table v-if="flagDisplayTable" class="table">
            <thead>
                <tr>
                    <th class="text-center" style="width: 30%;">{{ labelOrganizationTableColumn1[actualLanguage] }}</th>
                    <th class="text-center" style="width: 30%;">{{ labelOrganizationTableColumn2[actualLanguage] }}</th>
                    <th class="text-center" style="width: 10%;">{{ labelOrganizationTableColumn3[actualLanguage] }}</th>
                    <th class="text-center" style="width: 15%;">{{ labelOrganizationTableColumn4[actualLanguage] }}</th>
                </tr>
            </thead>
            <tbody>   
                  <tr v-for="(subOrganization,index) in managedOrganizations">
                      <td class="text-center">
                        {{subOrganization.organizationName}} [{{subOrganization.organizationId}}]
                      </td>

                      <td class="text-center">
                        {{subOrganization.subscriptionTitle[actualLanguage]}}
                      </td>

                      <td v-if="subOrganization.subscriptionActive" class="text-center">
                        <i class="fa fa-check"></i>
                      </td>
                      <td v-else class="text-center">
                        <i class="fa fa-times"></i>
                      </td>

                      <td class="text-center">
                          <div>
                              <button class="btn btn-block  btn-default" type="button" @click="openApplyPlanToSubOrganization(index)" data-toggle="tooltip">
                              <i class="fa fa-plus"></i> {{labelTableApplyPlan[actualLanguage]}}</button>
                              <button v-if="subOrganization.subscriptionActive" class="btn btn-block btn-default btn-block" type="button" @click="openModifyPlanToSubOrganization(index)" data-toggle="tooltip">
                              <i class="fa fa-pencil"></i> {{labelTableModifyPlan[actualLanguage]}}</button>
                          </div>
                      </td>
                  </tr>
            </tbody>
        </table>



        <!-- --------------------------------- -->
        <!-- APPLY PLAN !! -->
        <!-- --------------------------------- -->
        <div v-if="flagDisplayAddPlan" class="col-xs-12 col-sm-12 push">

          <div class="content content-boxed">
            <div class="block block-bordered">
              <div  class="block-content">
                <div class="row">

                    <div class="col-xs-12 col-sm-12 push">
                      <button  type="button" @click="cancelAddModifyPlan()" class="btn btn-default align-right" name="buttonAddPlanItem">
                      <i class="fa fa-times fa-1x push-5-r "></i>{{ labelButtonCancel[actualLanguage] }}</button>
                    </div>
                    
                    <div class="col-xs-12 col-sm-12 push">
                      <h4>{{labelApplyPlanTo [actualLanguage]}} {{managedOrganizations[selectedOrganizationIndex].organizationName}}</h4>
                    </div>

                     <div class="col-xs-12 col-sm-12 push">
                      <h5>{{labelActualPlan[actualLanguage]}} {{managedOrganizations[selectedOrganizationIndex].subscriptionTitle[actualLanguage]}}</h5>
                    </div>

                    <div class="col-sm-12 push">
                        <select class="form-control" @click="readSelectedPlanDetail()" v-model=selectedPlanSortKey size="1">
                            <option v-for="plan in planDescription" :value="plan.sort_key">{{plan.planInfo.title[actualLanguage]}}</option>
                        </select>
                    </div>

                    <div v-if="selectedPlanSortKey.length  > 3  & planSelectedFlag" class="col-sm-12 push">

                      <!-- --------------------------------- -->
                      <!-- Display selected plan detail !! -->
                      <!-- --------------------------------- -->

                      <div class="col-xm-12 col-md-12">
                          <!-- Startup Plan -->

                          <a class="block block-bordered block-link-hover3 text-center">
                              <div class="block-header">
                                  <h2 class="font-w200 text-center">{{selectedPlanDetail.planInfo.title[actualLanguage]}}</h2>

                                  <div v-for="(descriptionLine, index) in selectedPlanDetail.planInfo.description" class="col-xm-12 col-md-12">
                                    <h6  class="font-w200 text-center push">{{descriptionLine[actualLanguage]}}</h6>
                                  </div>
                                  <hr size="50">

                                  <h4  class="font-w200 text-center">{{textSubscriptionOrgLicenceSection[actualLanguage]}}</h4>
                                  <h6  class="font-w200 text-center push">{{selectedPlanDetail.organizationLicenceData.licenceTitle[actualLanguage]}}</h6>
                                  <h6  class="font-w200 text-center">{{selectedPlanDetail.organizationLicenceData.priceDescription[actualLanguage]}} : </h6>
                                  <h5  class="h1 font-w700 push-10">{{selectedPlanDetail.organizationLicenceData.price}} $ </h5>
                                  <div v-if="selectedPlanDetail.organizationLicenceData.options.length > 100">
                                      <h5  class="content-heading align-center">{{textSubscriptionLicenceOptionSection[actualLanguage]}}</h5>
                                      <div v-for="(optionLine, optionIndex) in selectedPlanDetail.organizationLicenceData.options" :key="optionIndex" class="col-xm-12 col-md-12">
                                        <h5 class="font-w200 text-center">{{optionLine.title[actualLanguage]}}</h5>

                                        <h6  class="font-w200 text-center">{{optionLine.description[actualLanguage]}}</h6>
                                        <h6  class="font-w200 text-center">{{optionLine.priceDescription[actualLanguage]}}</h6>
                                        <h6  class="h3 font-w700 push-10">{{optionLine.price}} $ </h6>
                                        
                                      </div>
                                  </div>


                                  <hr size="50">

                                  <div class="col-sm-12 push" v-if="parseFloat(selectedPlanDetail.planInfo.maximumLicenceCount) > parseFloat(selectedPlanDetail.planInfo.includedLicence)">
                                    <h4  class="font-w200 text-center">{{textSubscriptionUserLicenceSection[actualLanguage]}}</h4>
                                    <h6  class="font-w200 text-center push">{{selectedPlanDetail.userLicenceData.licenceTitle[actualLanguage]}}</h6>
                                    <h6  class="font-w200 text-center">{{selectedPlanDetail.userLicenceData.priceDescription[actualLanguage]}} : </h6>
                                    <h5  class="h1 font-w700 push-10">{{selectedPlanDetail.userLicenceData.price}} $ </h5>


                                    <div v-if="selectedPlanDetail.userLicenceData.options.length > 100">
                                        <h5  class="content-heading align-center">{{textSubscriptionLicenceOptionSection[actualLanguage]}}</h5>
                                        <div v-for="(optionLine2, optionIndex2) in selectedPlanDetail.userLicenceData.options" :key="optionIndex2" class="col-xm-12 col-md-12">
                                          <h5 class="font-w200 text-center">{{optionLine2.title[actualLanguage]}}</h5>

                                          <h6  class="font-w200 text-center">{{optionLine2.description[actualLanguage]}}</h6>
                                          <h6  class="font-w200 text-center">{{optionLine2.priceDescription[actualLanguage]}}</h6>
                                          <h6  class="h3 font-w700 push-10">{{optionLine2.price}} $ </h6>
                                          
                                        </div>
                                    </div>
                                  </div>
                                  <hr size="50">


                                  <!-- ================================================================= -->
                                  <!-- Affichage de la charte de rabais de volume -->
                                  <!-- ================================================================= -->
                                  
                                  <div class="col-sm-12 push">
                                    <h4  class="font-w200 text-center">{{textRebateTableTitle[actualLanguage]}}</h4>
                                    <h6  class="font-w200 text-center">{{textRebateTableSubTitle[actualLanguage]}}</h6>
                                    <table class="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th class="text-center" style="width: 30%;">{{textRebateTableColumn01[actualLanguage]}}</th>
                                                <th class="text-center" style="width: 30%;">{{textRebateTableColumn02[actualLanguage]}}</th>
                                                <th class="text-center" style="width: 30%;">{{textRebateTableColumn03[actualLanguage]}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(rebateSlice) in selectedPlanDetail.rebateChartData.chart">
                                                <td class="text-center">{{rebateSlice.priceSliceMin}} $</td>
                                                <td class="text-center">{{rebateSlice.priceSliceMax}} $</td>
                                                <td class="text-center">{{rebateSlice.pourcentageReduction}} %</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                  </div>

                              </div>
                          </a>

                          <!-- END Startup Plan -->
                      </div>


                        <button  @click="applyPlanToSelectedOrganization()" type="button" class="btn btn-success align-right">
                          <spinner size="small" v-if="planIsSaving"></spinner>
                          <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelButtonActualPlan[actualLanguage] }}</span></button>
                    </div>

                  </div>
                </div>
              </div>
            
          </div>
        </div>



        <!-- --------------------------------- -->
        <!-- EDIT PLAN -->
        <!-- --------------------------------- -->
        <div v-if="flagDisplayModifyPlan" class="col-xs-12 col-sm-12 push">
            
            <h2 class="block-title push">{{labelModifyOrganizationPlan[actualLanguage]}}</h2>
            <h4 >{{managedOrganizations[selectedOrganizationIndex].organizationName}}</h4>

            <spinner size="normal" v-if="subscriptionIsLoading"></spinner>
            <div v-else class="col-xs-12 col-sm-12 push">


              <button  type="button" @click="cancelAddModifyPlan()" class="btn btn-default align-right" name="buttonAddPlanItem">
              <i class="fa fa-times fa-1x push-5-r "></i>{{ labelButtonCancel[actualLanguage] }}</button>


              <!-- ================================================================= -->
              <!-- Section d'affichage du détail de la licence Organisation -->
              <!-- ================================================================= -->
              
              <div class="row">
                <div class="col-sm-12 col-md-12">
                  <h3 class="font-w300 push">{{ sectionLabelLicenceOrganization[actualLanguage] }}</h3>
                </div>

                <div class="col-sm-12 col-lg-12">
                    <div class="block block-bordered">
                        <div class="block-header bg-gray-lighter">
                            <ul class="block-options">
                                <li>
                                    <button type="button"><i class="fa fa-key"></i></button>
                                </li>
                            </ul>
                            <h3 class="block-title">{{subOrganizationSubscription.organization_licence.title[actualLanguage]}}</h3>
                        </div>


                        <div class="block-content">
                          <div class="col-sm-6 col-lg-6">
                            <h4>Licence ID:{{subOrganizationSubscription.subscription_id.substring(11,30)}}</h4>
                          </div>
                          <div class="col-sm-6 col-lg-6 ">
                            <h3 class="align-right">{{baseCostLabel[actualLanguage]}} : {{subOrganizationSubscription.organization_licence.price}} $</h3>
                          </div>

                          <table v-if="subOrganizationSubscription.organization_licence.customizedOptions.length > 0" class="table">
                              <thead>
                                  <tr>
                                      <th class="text-center" style="width: 25%;">{{selectPlanOptionColumnTitle01[actualLanguage]}}</th>
                                      <th class="text-center" style="width: 55%;">{{selectPlanOptionColumnTitle02[actualLanguage]}}</th>
                                      <th class="text-center" style="width: 20%;">{{selectPlanOptionColumnTitle03[actualLanguage]}}</th>
                                  </tr>
                              </thead>
                              <tbody>   
                                    <tr v-for="(licenceOption,index) in subOrganizationSubscription.organization_licence.customizedOptions">
                                        <td class="text-center">{{licenceOption.title[actualLanguage]}}.  {{licenceOption.priceDescription[actualLanguage]}}:{{licenceOption.price}} $ </td>
                                        <td class="text-center">{{licenceOption.description[actualLanguage]}}</td>

                                        <td v-if="licenceOption.valueType=='NUMERIC'" class="text-center">
                                          <h6  class="h6 font-w700 push-10">{{maxValueLabel[actualLanguage]}} </h6>
                                          <input v-model="licenceOption.value" class="form-control text-center"  placeholder="Valeur/Value">
                                        </td>
                                        <td v-if="licenceOption.valueType=='BOOL'" class="text-center">
                                            <label class="css-input switch switch-success">
                                              <input type="checkbox" checked v-model="licenceOption.value">
                                              <span></span> Activation
                                            </label>                       
                                        </td>
                                    </tr>
                              </tbody>
                          </table>

                          <!-- ================================================================= -->
                          <!-- Section d'affichage des autres coûts -->
                          <!-- ================================================================= -->
                          <div class="row push">
                            <div class="col-sm-12 col-lg-12">
                              <h4 >{{labelOtherCostSection[actualLanguage]}}</h4>
                            </div>

                            <table v-if="subOrganizationSubscription.subscription_other_fees.length > 0" class="table">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 15%;">{{otherFeeColumnTitle01[actualLanguage]}}</th>
                                        <th class="text-center" style="width: 55%;">{{otherFeeColumnTitle02[actualLanguage]}}</th>
                                        <th class="text-center" style="width: 20%;">{{otherFeeColumnTitle03[actualLanguage]}}</th>
                                        <th class="text-center" style="width: 15%;">{{otherFeeColumnTitle04[actualLanguage]}}</th>
                                    </tr>
                                </thead>
                                <tbody>   
                                      <tr v-for="(fee,indexFee) in subOrganizationSubscription.subscription_other_fees">
                                          <td class="text-center">
                                            <input v-model="fee.quantity" class="form-control text-center"  placeholder="Valeur/Value">
                                          </td>
                                          <td class="text-center">{{fee.description[actualLanguage]}}</td>

                                          <td class="text-center">
                                            <input v-model="fee.unitCost" class="form-control text-center"  placeholder="Valeur/Value">
                                          </td>
                                          <td class="text-center">
                                            <button @click="deleteFeeLine(indexFee)" class="btn btn-md btn-danger align-center" type="button" title="Retirer/Release"><i class="fa fa-times"></i></button>
                                          </td>
                                      </tr>
                                </tbody>
                            </table>




                            <div v-if="flagAddOtherFeeSection==false" class="col-sm-12 col-lg-12">
                              <p><button @click="openAddOtherFee()" type="button" class="btn btn-success align-right push" name="button">{{ labelButtonAddOtherFees[actualLanguage] }}</button></p>
                            </div>

                            <div v-else class="content content-boxed">
                              <div class="block block-bordered">
                                <div  class="block-content">
                                  <div class="row">

                                    <div class="col-sm-12 push">
                                        <select class="form-control" v-model=selectedFeeToAdd  size="1">
                                            <option v-for="fee in otherFeesList" :value="fee.data">{{fee.data.description[actualLanguage]}}</option>
                                        </select>
                                    </div>

                                    <p v-if="selectedFeeToAdd.quantity"><button @click="addSelectedFee()" type="button" class="btn btn-success align-right push" name="button">{{ labelButtonAddSelectedFees[actualLanguage] }}</button></p>

                                    <p><button @click="closeAddOtherFee()" type="button" class="btn btn-danger align-right push" name="button">{{ labelButtonAddOtherFeesCancel[actualLanguage] }}</button></p>

                                  </div>
                                </div>
                              </div>
                            </div>


                            <div class="col-sm-12 col-lg-12">
                              <p><button @click="saveSubscriptionModification()" type="button" class="btn btn-success align-right" name="button">{{ labelButtonSaveSupscription[actualLanguage] }}</button></p>
                            </div>
                            
                          </div>

                        </div>

                    </div>
                </div>
              </div>





              <!-- ================================================================= -->
              <!-- Section d'affichage du détail des licences usagers -->
              <!-- ================================================================= -->
              <div class="row">
                <div class="col-sm-12 col-md-12">
                  <h3 class="font-w300 push">{{ sectionLabelLicence[actualLanguage] }}</h3>
                </div>

                <div v-if="displayUserLicenceSectionFLag"  class="col-sm-12 col-lg-12">
                    <div v-for ="(userLicence,index) in subOrganizationSubscription.organization_user_licences" class="block block-bordered">
                        <div class="block-header bg-gray-lighter">
                            <ul class="block-options">
                                <li>
                                    <button type="button"><i class="fa fa-key"></i></button>
                                </li>
                            </ul>
                            <h3 class="block-title" @click="toggleDisplayUserLicenceFlag(index)">{{userLicence.title[actualLanguage]}} ID: {{userLicence.licenceId.substring(11,30)}}</h3>
                        </div>


                        <div v-if="displayUserLicenceFlag[index]" class="block-content">
                          <div class="col-sm-12 col-lg-12 push">
                            <div class="col-sm-12 col-lg-12 ">
                              <h3 class="align-right">{{baseCostLabel[actualLanguage]}} : {{userLicence.price}} $</h3>
                            </div>
                          </div>
                          <div class="col-sm-12 col-lg-12 push">
                            <div class="col-sm-6 col-lg-6 ">
                              <h3 v-if="userLicence.linkedProfile.email != 'NONE'" class="align-left">{{ tableLicenceUser[actualLanguage] }} : {{userLicence.linkedProfile.email}}</h3>
                              <h3 v-else class="align-left">Disponible/Available</h3>
                            </div>
                          </div>

                          <div v-if="userLicence.linkedProfile.email == 'NONE' && index >= subOrganizationSubscription.organization_plan_description.planInfo.includedLicence" class="col-sm-12 col-lg-12">
                              <button @click="deleteLicence(index)" class="btn btn-md btn-danger align-right" type="button" title="Supprimer/Delete"><i class="fa fa-times"></i> {{ buttonLabelDeleteLicence[actualLanguage] }}</button>
                          </div>
                          
                          <table class="table">
                              <thead v-if="userLicence.customizedOptions.length > 0">
                                  <tr>
                                      <th class="text-center" style="width: 25%;">{{selectPlanOptionColumnTitle01[actualLanguage]}}</th>
                                      <th class="text-center" style="width: 55%;">{{selectPlanOptionColumnTitle02[actualLanguage]}}</th>
                                      <th class="text-center" style="width: 20%;">{{selectPlanOptionColumnTitle03[actualLanguage]}}</th>
                                  </tr>
                              </thead>
                              <tbody>   
                                    <tr v-for="(licenceOption,index) in userLicence.customizedOptions">
                                        <td class="text-center">{{licenceOption.title[actualLanguage]}}.  {{licenceOption.priceDescription[actualLanguage]}}:{{licenceOption.price}} $ </td>
                                        <td class="text-center">{{licenceOption.description[actualLanguage]}}</td>

                                        <td v-if="licenceOption.valueType=='NUMERIC'" class="text-center">
                                          <h6  class="h6 font-w700 push-10">{{maxValueLabel[actualLanguage]}} </h6>
                                          <input v-model="licenceOption.value" @change="computeCost()" class="form-control text-center"  placeholder="Valeur/Value">
                                        </td>
                                        <td v-if="licenceOption.valueType=='BOOL'" class="text-center">
                                            <label class="css-input switch switch-success">
                                              <input type="checkbox" checked v-model="licenceOption.value" @change="computeCost()">
                                              <span></span> Activation
                                            </label>                       
                                        </td>
                                    </tr>
                              </tbody>
                          </table>
                        </div>


                    </div>
                </div>
              </div>

              <!-- ================================================================= -->
              <!-- Section d'affichage du détaile de l'abonnement -->
              <!-- ================================================================= -->
              <div class="row">
                <h5>Date dernier renouvellement / Last renewal date :   {{subOrganizationSubscription.renewal_last_date}}</h5>
                <h5 class="push">Date prochain renouvellement / Next renewal date :   {{subOrganizationSubscription.renewal_date}}</h5>

                <h5>Type de paiement / Paiement type :   {{subOrganizationSubscription.payment_type}}</h5>
              </div>


            </div>
        </div>

    </div>
    
  </div>





</div>
</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'


export default {
  name: 'GroupIndex',
  props: ['organization'],
  data() {
    return {
      flagDisplayAddOrganization : -1,
      profileIsSaving : false,
      actualLanguage : "FR",
      labelTitleSection: {FR: 'Gestion des organisations client', EN: 'Costumer organization management'},
      labelButtonAddOrganization: {FR: 'Ajouter une organisation', EN: 'Add organization'},
      labelButtonCancel: {FR: 'Annuler', EN: 'Cancel'},
      labelButtonAdd: {FR: 'Ajouter', EN: 'Add'},

      labelOrganizationToAddId: {FR: "ID de l'organisation", EN: 'Organization ID'},
      labelOrganizationToPhoneNumber: {FR: "Numéro de téléphone de l'organisation", EN: 'Organization phone number'},
      organizationToAddId : '',
      organizationToAddPhoneNumber : '',

      organizationIsSaving : false,
      organizationListIsLoading : false,
      managedOrganizations : [],
      labelOrganizationTableColumn1 : {FR: "Nom organisation", EN: 'Organization name'},
      labelOrganizationTableColumn2 : {FR: "Abonnement", EN: 'Subscription'},
      labelOrganizationTableColumn3 : {FR: "Actif", EN: 'Active'},
      labelOrganizationTableColumn4 : {FR: "Action", EN: 'Action'},
      labelTableApplyPlan : {FR: "Appliquer un abonnement", EN: 'Apply subscription'},
      labelTableModifyPlan : {FR: "Modifier l'abonnement", EN: 'Modify subscription'},

      flagDisplayTable : true,
      flagDisplayAddPlan : false,
      flagDisplayModifyPlan : false,
      selectedOrganizationIndex : 0,

      labelApplyPlanTo : {FR: "Appliquer un abonnement à l'organisation:", EN: 'Apply subscription to the organization:'},
      labelActualPlan : {FR: "Plan actuel de l'organisation:", EN: 'Actual plan of the organization:'},
      labelButtonActualPlan : {FR: "Appliquer le plan sélectionné", EN: 'Apply selected plan'},
      planDescription : [],
      selectedPlanSortKey : 'TBD',
      planSelectedFlag : false,
      selectedPlanDetail : {},
      planIsSaving : false,
      messagePromptConfirmApplyNewPlan : {FR: "Confirmer l'application du nouveau plan.", EN: 'Confirm subscription change.'},

      textSubscriptionDescriptionTitle04: {FR: "Plans disponibles", EN: 'Available plans'},
      textSubscriptionOrgLicenceSection: {FR: "Licence de l'organisation", EN: 'Organisation licence'},
      textSubscriptionUserLicenceSection: {FR: "Licence utilisateur (additionelles)", EN: 'User licence (additional)'},
      textSubscriptionLicenceOptionSection: {FR: "Détails et options de la licence:", EN: 'Licence detail and options:'},
      textRebateTableTitle:{FR: "Charte de rabais de volume", EN: 'Volume rebate chart'},
      textRebateTableSubTitle:{FR: "Rabais par tranche de coût de base (mensuel).",
                               EN: 'Discount per base cost bracket (monthly).'},
      textRebateTableColumn01:{FR: "De:", EN: 'From:'},
      textRebateTableColumn02:{FR: "À:", EN: 'To:'},
      textRebateTableColumn03:{FR: "% Rabais", EN: '% Rebate'},


      labelModifyOrganizationPlan : {FR: "Modification de l'abonnement de l'organisation", EN: 'Modification of the organization subscrition'},
      subscriptionIsLoading : false,
      subOrganizationSubscription : {},


      sectionLabelLicenceOrganization:{FR: "Détails du forfait de l'organisation", EN: 'Organization subscription details and options'},
      baseCostLabel:{FR: "Coût de base", EN: 'Base cost'},
      selectPlanOptionColumnTitle01: {FR: "Option", EN: 'Option'},
      selectPlanOptionColumnTitle02: {FR: "Description", EN: 'Description'},
      selectPlanOptionColumnTitle03: {FR: "Activation de l'option / Valeur maximum", EN: 'Option activation / Maximum value'},
      maxValueLabel: {FR: "Valeur maximale (limite)", EN: 'Maximum value (limit)'},
      buttonLabelDeleteLicence: {FR: "Supprimer cette licence", EN: 'Delete this licence'},
      buttonLabelAddUserLicence: {FR: "Ajouter une licence usager", EN: 'Add user licence'},


      sectionLabelLicence:{FR: "Licences usagers", EN: 'Users licenses'},
      displayUserLicenceSectionFLag : true,
      displayUserLicenceFlag : [],
      tableLicenceType:{FR: "Type", EN: 'Type'},
      tableLicenceUser:{FR: "Utilisateur lié", EN: 'Linked user'},
      tableLicenceAction:{FR: "Action", EN: 'Action'},
      buttonLabelRemoveLicence:{FR: "Retirer", EN: 'Remove'},
      buttonLabelAllocate:{FR: "Allouer la licence", EN: 'Allocate the licence'},
      sectionLabelSubscriptionFees:{FR: "Frais d'abonnement", EN: 'Subscription fees'},


      labelOtherCostSection: {FR: "Autres frais", EN: 'Other fees'},
      otherFeesList : [],
      flagAddOtherFeeSection : false,
      labelButtonAddOtherFees : {FR: "Ajouter un frais", EN: 'Add other fees'},
      labelButtonAddSelectedFees : {FR: "Ajouter", EN: 'Add'},
      labelButtonAddOtherFeesCancel : {FR: "Annuler", EN: 'Cancel'},
      selectedFeeToAdd : {},
      otherFeeColumnTitle01 : {'FR':'Quantité','EN':'Quantity'},
      otherFeeColumnTitle02 : {'FR':'Description','EN':'Description'},
      otherFeeColumnTitle03 : {'FR':'Coût unitaire','EN':'Unit price'},
      otherFeeColumnTitle04 : {'FR':'Supprimer','EN':'Delete'},

      labelButtonSaveSupscription : {FR: "Enregistrer les modifications à l'abonnement", EN: 'Save subscription modifications'},

    }
  },
  components: {
    Spinner
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayAddOrganization(){
      this.flagDisplayAddOrganization = ~this.flagDisplayAddOrganization
    },


    addNewOrganisation() {
        this.organizationIsSaving = true
        var requestData = { 'postAction':'IntegratorAddNewOrganization',
                            'organizationId': this.organization.organizationId,
                            'organizationToAddId': this.organizationToAddId,
                            'organizationToAddPhoneNumber':this.organizationToAddPhoneNumber
                            }     
        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              this.organizationIsSaving = false
              
              //console.log(response)
            if(response.data.Code=='OK'){
                this.getListSubOrganizations()
                }
                else{ 
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })       
      
    },


    getListSubOrganizations() {
        this.organizationListIsLoading= true
        var requestData = { 'postAction':'GetListSubOrganization',
                            'organizationId': this.organization.organizationId,
                            }     
        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              this.organizationListIsLoading = false
              //console.log(response)
            if(response.data.Code=='OK'){
                this.managedOrganizations = response.data.subOrganizations
                }
                else{ 
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })       
      
    },

    getAdminPlanList(){
      var requestData = { 'postAction':'GetAdminPlanList',
                          'subscriptionListId': process.env.VAR_PLAN_ADMIN_LIST,
                          'organizationId':this.organization.organizationId,
                          }

      this.$store.dispatch('sessionStore/processSubscription', requestData)
        .then((response) => {
          if(response.data.Code=='OK'){
            //console.log('--PLAN LIST---')
            //console.log(response.data)
            this.planDescription = response.data.PlanList
            }
        })
    },


    getOtherFeesList(){
      var requestData = { 'postAction':'IntegratorGetOtherFeesList'}

      this.$store.dispatch('sessionStore/processSubscription', requestData)
        .then((response) => {
          if(response.data.Code=='OK'){
            this.otherFeesList = response.data.FeesList
            }
        })
    },


    openApplyPlanToSubOrganization(index){
      this.selectedOrganizationIndex = index
      this.flagDisplayTable = false
      this.flagDisplayAddPlan = true
      this.flagDisplayModifyPlan = false

    },

    readSelectedPlanDetail(){

      this.selectedPlanDetail = {}
      this.planSelectedFlag = false
      for(var n=0;n<this.planDescription.length;n++){
        if(this.planDescription[n].sort_key==this.selectedPlanSortKey){
          this.selectedPlanDetail =this.planDescription[n]
          //console.log(this.selectedPlanDetail)
          this.planSelectedFlag = true
        }
        }

    },

    applyPlanToSelectedOrganization(){
        var ProceedToAction = false

        if (window.confirm(this.messagePromptConfirmApplyNewPlan[this.actualLanguage])){
            ProceedToAction = true
        }

        if(ProceedToAction){
            this.planIsSaving = true
            var requestData = {'postAction':'IntegratorApplySubscription',
                                'integratorOrganizationId': this.organization.organizationId,
                                'subOrganizationId':this.managedOrganizations[this.selectedOrganizationIndex].organizationId,
                                'selectedPlanDetail': this.selectedPlanDetail}
            this.$store.dispatch('sessionStore/processSubscription', requestData)
                .then((response) => {
                this.planIsSaving =  false
                if(response.data.Code=='OK'){
                    this.cancelAddModifyPlan()
                    this.getListSubOrganizations()
                    }
                    else{
                      window.alert(response.data.PromptMessage[this.actualLanguage])
                      }
                })
        }

    },

    cancelAddModifyPlan(){
      this.flagDisplayTable = true
      this.flagDisplayAddPlan = false
      this.flagDisplayModifyPlan = false
    },

    openModifyPlanToSubOrganization(index){
      this.selectedOrganizationIndex = index
      this.flagDisplayTable = false
      this.flagDisplayAddPlan = false
      this.flagDisplayModifyPlan = true


      this.subscriptionIsLoading = true
      var requestData = {'postAction':'IntegratorReadSubOrganizationSubscription',
                          'integratorOrganizationId': this.organization.organizationId,
                          'subOrganizationId':this.managedOrganizations[this.selectedOrganizationIndex].organizationId}
      this.$store.dispatch('sessionStore/processSubscription', requestData)
          .then((response) => {
          this.subscriptionIsLoading =  false
          if(response.data.Code=='OK'){
              //console.log(response.data.SubscriptionData)
              this.subOrganizationSubscription = response.data.SubscriptionData
              this.displayUserLicenceFlag = []
              for(var m = 0;m < this.subOrganizationSubscription.organization_user_licences.length;m++){this.displayUserLicenceFlag.push(0)}
              }
              else{
                window.alert(response.data.PromptMessage[this.actualLanguage])
                }
          })


    },


    openAddOtherFee(){
      this.flagAddOtherFeeSection = true
      this.selectedFeeToAdd = {}
    },
    closeAddOtherFee(){
      this.flagAddOtherFeeSection = false
    },
    addSelectedFee(){
      this.subOrganizationSubscription.subscription_other_fees.push(this.selectedFeeToAdd)
      this.flagAddOtherFeeSection = false
    },
    deleteFeeLine(index){
      this.subOrganizationSubscription.subscription_other_fees.pop(index)
    },

    toggleDisplayUserLicenceFlag(index){
      this.displayUserLicenceSectionFLag = false
      this.displayUserLicenceFlag[index]=~this.displayUserLicenceFlag[index]
      this.displayUserLicenceSectionFLag = true
    },

    saveSubscriptionModification(){
      var requestData = { 'postAction':'IntegratorSaveSubOrganizationSubscription',
                          'subscriptionData': this.subOrganizationSubscription,
                          }

      this.$store.dispatch('sessionStore/processSubscription', requestData)
        .then((response) => {
          if(response.data.Code=='OK'){
            //console.log('--PLAN LIST---')
            console.log(response.data)
            }
        })
    },


    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()
    this.getAdminPlanList()
    this.getListSubOrganizations()
    this.getOtherFeesList()


    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>





// WEBPACK FOOTER //
// IntegratorSubOrganization.vue?ac1b66be